import { env } from "../env/runtime";
import { AppError, authError } from "./app-error";
import { authClient } from "./auth-client";
import { checkFirmMembership } from "./firm-exit";
import type { ApiBases, RegionalOptions } from "./regional-request";
import { createRegionalTokenCache } from "./regional-token-cache";

/** Each region's API; a regional token's region picks which one a call goes to. */
export const regionalApiBases: ApiBases = {
  au: env.VITE_API_URL_AU,
  ...(env.VITE_API_URL_US ? { us: env.VITE_API_URL_US } : {}),
};

// This module never writes tokens to browser storage or exposes them through the desktop bridge.
export const regionalTokens = createRegionalTokenCache(async (signal) => {
  try {
    const response = await authClient.token({ fetchOptions: { signal } });
    if (response.error) throw authError(response.error, "token");
    if (!response.data?.token) throw new AppError("INVALID_RESPONSE");
    return response.data.token;
  } catch (error) {
    const refusal = authError(error, "token");
    // A refused mint is how a removed person's browser finds out: their pointers were cleared and
    // their seat is gone. It is only a hint, so the firm check decides whether to leave.
    if (refusal.code === "WORKSPACE_REQUIRED" || refusal.code === "WORKSPACE_ACCESS_DENIED") {
      void checkFirmMembership();
    }
    throw refusal;
  }
});

/** What every regional call needs: the token cache and the APIs. Callers add their own bound. */
export const regionalOptions: RegionalOptions = {
  cache: regionalTokens,
  apiBases: regionalApiBases,
};
